import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Inject, Input } from '@angular/core';
import { BootstrapMarketoService } from 'lib/services/bootstrap/bootstrap-marketo.service';
import { CategoryService } from 'lib/services/category/category.service';
import { RouterService } from 'lib/services/router.service';
import { WebpService } from 'lib/services/webp.service';
import { CommonModule, Location } from '@angular/common';
import { CmsPartialComponentClass } from 'lib/components/cms/cms-partial-component.class';
import { SpecialModule } from 'lib/modules/special.module';

@Component({
    selector: 'cms-partial-category-top-component-full-width-image-and-text',
    templateUrl: './full-width-image-and-text.component.html',
    styleUrls: ['./full-width-image-and-text.component.scss'],
    standalone: true,
    imports: [CommonModule, SpecialModule],
})
export class FullWidthImageAndTextComponent extends CmsPartialComponentClass {
    @Input() fullWidthImageAndTextRow: any;
    @Input() dataUrl: string;
    @Input() dataTitle: string;
    @Input() solutionID: string;
    @Input() grayBackgroundRows: any = [];
    getWebpImg: (src: string) => string;

    constructor(
        @Inject('environment') environment: any,
        breakpointObserver: BreakpointObserver,
        public bootstrapMarketoService: BootstrapMarketoService,
        routerService: RouterService,
        webpService: WebpService,
        location: Location,
        categoryService: CategoryService
    ) {
        super({
            dependencies: {
                bootstrapMarketoService,
                breakpointObserver,
                environment,
                routerService,
                location,
                categoryService,
                webpService,
            },
        });
        this.getWebpImg = (src: string) => webpService.getWebpImg(src);
    }
}
